// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";

import http from "@http";
import actionCreators from "@modules/settings/actionCreator";
import { transformError } from "@transformers/response";
import { GetSettings } from "@modules/settings/constants/actions";
import type { Settings } from "@modules/settings/types";

type SettingsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetSettings({ payload }: Action<SettingsRequest>): Generator<*, void, Settings> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const [
      clientSettings,
      serviceSettings,
      employeeIdentity,
      userPermissions,
      reportingParameters,
    ] = yield all([
      call(http.get, `/api/v1/client-admin/client/${payload.clientId}/service/absence-management`),
      call(
        http.get,
        `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/service-settings`,
      ),
      call(
        http.get,
        `/api/v2/service-admin/client/${payload.clientId}/service-config/platform/data-security-employee-identity`,
      ),
      call(
        http.get,
        `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/user-permissions`,
      ),
      call(
        http.get,
        `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/reporting-parameters`,
      ),
    ]);

    const settings = {
      clientSettings: clientSettings.data,
      serviceSettings: {
        ...serviceSettings.data,
        employeeIdentity: employeeIdentity.data,
        userPermissions: userPermissions.data,
        reportingParameters: reportingParameters.data,
      },
    };

    yield put(actionCreators.GetSettingsSuccess(settings));
  } catch (e) {
    console.error("Saga error: ", e);
    const error = e && e.response ? transformError(e) : e;
    yield put(actionCreators.GetSettingsError(error));
  }
}

// ROOT

export function* SettingsSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetSettings, onGetSettings)]);
}

export default SettingsSagas;
